<template>
  <w-multiple-key-value-filter
    v-bind="$props"
    :override-flat-object="overrideFlatObject"
    :with-false-value="withFalseValue"
    :filter-options="hasFilterOption ? filterOptions : []"
    :filter-option-value="filterOptionValue"
    :option-search-key="attributeOptionSearchKey"
    :option-select-disabled="!moreThanOneAttributesSelected"
    :mandatory-filters="mandatoryFilters"
    v-on="$listeners"
    @input="$emit('input', $event)"
  />
</template>

<script>
import filterHierarchyStructureMixin from '@/mixins/filter-hierarchy-structure-mixin';

import i18n from '@/language/i18n';

const overrideFlatObject = (item) => {
  return {
    id: item.id,
    label: `${item.data.convertLabel}` + ' ' + (item?.data?.attributeName ? `(${item?.data?.attributeName})` : ''),
  };
};

/**
 * @component WorkCategoryAttributeFilter
 * @description Product attribute filter with hierarchy structure.
 * Loads attributes from the API and supports multi-selection with true/false options.
 *
 * @prop {Object|Array} [value] - Selected values (v-model).
 * @prop {String} [label] - Field label (default: translation for 'Attribute').
 * @prop {String} [filterName='attributes'] - Filter identifier.
 * @prop {String} [path='productcategories/attributes'] - API path for attributes.
 * @prop {String} [itemText='data.convertLabel'] - Path to the display text.
 * @prop {String} [itemValue='id'] - Path to the value.
 * @prop {String} [itemChildren='data.discreteValues'] - Path to child nodes.
 * @prop {Boolean} [clearable=true] - Show clear button.
 * @prop {Boolean} [disabled=false] - Disable filter.
 * @prop {String} [attributeOptionSearchKey='attributeRelation'] - Search key for attribute filter options.
 * @prop {Boolean} [withFalseValue=true] - Show "false" option.
 * @prop {Boolean} [hasFilterOption=false] - Show filter option buttons.
 * @prop {Object} [attributeTableFilters] - Additional table filters.
 * @prop {Object} [mandatoryFilters] - Mandatory filters for API queries.
 *
 * @emits {Array} input - Emitted when the selection changes.
 */
export default {
  name: 'WorkCategoryAttributeFilter',
  props: {
    value: { type: [Object, Array] },
    label: { type: String, default: i18n.t('Common.attribute') },
    filterName: { type: String, default: 'attributes'},
    path: { type: String, default: 'productcategories/attributes' },
    itemText: { type: String, default: 'data.convertLabel' },
    itemValue: { type: String, default: 'id' },
    itemChildren: { type: String, default: 'data.discreteValues' },
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    attributeOptionSearchKey: { type: String, default: 'attributeRelation' },
    withFalseValue: { type: Boolean, default: true },
    hasFilterOption: { type: Boolean, default: false},
    attributeTableFilters: { type: Object, default: undefined},
    mandatoryFilters: { type: Object, default: undefined },
  },
  methods: {
    overrideFlatObject: overrideFlatObject,
  },
  mixins: [
    filterHierarchyStructureMixin(
      self => self.filterName,
      self => self.attributeOptionSearchKey,
      undefined, 
      self => self.attributeTableFilters ?? undefined
    )
  ]
};
</script>
